export default __webpack_public_path__ + "static/media/bus-station.a35bcf5b.svg";